import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import { LoadingButton } from '@mui/lab';
import downloadBulkCsvReport from 'utils/downloadBulkCsvReport';
import I18nLabel from './i18nLabel';

export const BulkCsvDownloadButton = ({ companyListId }: { companyListId: string }) => {
  const [loading, setLoading] = useState(false);

  const handleDownloadZipReports = async (): Promise<void> => {
    const filename = `output-esg-companyList-${companyListId}.zip`;
    await downloadBulkCsvReport({
      bulkId: companyListId,
      defaultFilename: filename,
    });
  };

  const handleClick = async () => {
    if (!loading) {
      setLoading(true);
      try {
        await handleDownloadZipReports();
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    }
  };

  return (
    <Box sx={{ m: 0, position: 'relative' }}>
      <LoadingButton
        onClick={handleClick}
        loading={loading}
        loadingPosition="start"
        startIcon={<DownloadIcon />}
        variant="contained"
      >
        <I18nLabel labelId="export-to-csv" defaultMessage="Export To CSV" />
      </LoadingButton>
    </Box>
  );
};
